import { useEffect } from 'react';
import type { TooltipProps } from 'recharts';

interface HoverSyncTooltipProps extends TooltipProps<number, string> {
  onHover: (
    payload: Record<string, unknown> | null,
    coordinate: { x?: number; y?: number } | null
  ) => void;
}

export function HoverSyncTooltip({ active, payload, coordinate, onHover }: HoverSyncTooltipProps) {
  useEffect(() => {
    if (active && payload && payload.length) {
      const row = (payload[0]?.payload as Record<string, unknown> | undefined) ?? null;
      onHover(row, coordinate ?? null);
    } else {
      onHover(null, null);
    }
  }, [active, payload, coordinate, onHover]);

  return null;
}
